import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M3 17.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm5-4a1.5 1.5 0 0 1 3 0v5a1.5 1.5 0 0 1-3 0zm5-4a1.5 1.5 0 0 1 3 0v9a1.5 1.5 0 0 1-3 0zm5-4a1.5 1.5 0 0 1 3 0v13a1.5 1.5 0 0 1-3 0z"
    }
  )
);
var SvgNetwork4Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Network4Outlined_default = SvgNetwork4Outlined;

export { Network4Outlined_default as default };
